import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const StatusCardWrapper = styled.div`
  display: flex;
  align-self: flex-start;
  flex: 0;
  flex-direction: column;
  gap: ${Spacing.S16};
  min-width: 220px;
  position: sticky;
  top: 0;
`
